import {
  getCommonProductTerms,
  getVerticalWidgetProductTerms,
  ServicesWithTerms,
} from '@sravni/react-ugc/lib/ProductTerms';
import { INSURANCE_OFFERS_FROM_VITRINS } from '@sravni/ugc/lib/specialOffers/lists';
import type { InsuranceOffersFromVitrinsType } from '@sravni/ugc/lib/specialOffers/types';

import type { OfferTab } from '../../helpers/getTabsInfo';

export const insuranceTabsInfo: Record<InsuranceOffersFromVitrinsType, OfferTab> = {
  [INSURANCE_OFFERS_FROM_VITRINS.dms]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS.dms },
    label: 'ДМС',
    generalLink: '/dms/',
    generalLinkLabel: 'Все предложения по добровольному медицинскому страхованию',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.healthInsurance),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.healthInsurance),
    advertisingCategory: 'ДМС',
  },
  [INSURANCE_OFFERS_FROM_VITRINS['strahovka-kriticheskie-bolezni']]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS['strahovka-kriticheskie-bolezni'] },
    label: 'Страхование от критических заболеваний',
    generalLink: '/strahovka-kriticheskie-bolezni/',
    generalLinkLabel: 'Все предложения по страхованию от критических заболеваний',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.criticalIllness),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.criticalIllness),
    advertisingCategory: 'Страхование от критических заболеваний',
  },
  [INSURANCE_OFFERS_FROM_VITRINS['strahovanie-domov']]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS['strahovanie-domov'] },
    label: 'Страхование домов',
    generalLink: '/strahovanie-domov/',
    generalLinkLabel: 'Все предложения по страхованию дома и дачи',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.homeInsurance),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.homeInsurance),
    advertisingCategory: 'Страхование домов',
  },
  [INSURANCE_OFFERS_FROM_VITRINS['strahovka-ot-klescha']]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS['strahovka-ot-klescha'] },
    label: 'Страховка от укуса клеща',
    generalLink: '/strahovka-ot-klescha/',
    generalLinkLabel: 'Все предложения по страховке от укуса клеща',
    linkToOneProduct: '',
    getConditions: getCommonProductTerms(ServicesWithTerms.strakhovaniyeOtUkusaKleshcha),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.strakhovaniyeOtUkusaKleshcha),
    advertisingCategory: 'Страховка от укуса клеща',
  },
};
